import { Injectable } from '@angular/core';
// const jwt = require('jsonwebtoken');

@Injectable({
  providedIn: 'root'
})
export class InjectIntercom {
  private intercomSrc = 'https://widget.intercom.io/widget/h40i50a3';
  private loadedScripts: string[] = [];
  private intercom: any;

  loadScript(src: string): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.loadedScripts.includes(src)) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.setAttribute('src', src);
      script.setAttribute('type', 'text/javascript');
      script.onload = () => {
        this.loadedScripts.push(src);
        resolve();
      };
      script.onerror = () => reject(`Script load error for ${src}`);
      if (!Array.from(document.head.children).find(el => el.getAttribute('src') === src)) {
        document.head.appendChild(script);
      }
    });
  }

  initIntercom(config: any) {
    console.log('initIntercom', config);
    this.loadScript(this.intercomSrc).then(l => {
      const w = (window as unknown) as any;
      this.intercom = w.Intercom;
      if (typeof this.intercom === 'function') {
        this.intercom('reattach_activator');
        this.intercom('update', w.intercomSettings);
      } else {
        const i: any = function() {
          i.c(arguments);
        };
        i.q = [];
        i.c = function(args) {
          i.q.push(args);
        };
        w.Intercom = i;
      }
      w.Intercom('boot', {
        app_id: 'h40i50a3',
        user_id: config.user_id,
        email: config.email,
        customer_type: config.customer_type,
        customer_type_detail: config.customer_type_details,
        customer_orders: config.customer_orders
      });
      if (w.attachEvent) {
        w.attachEvent('onload', l);
      } else {
        w.addEventListener('load', l, false);
      }
      return this.intercom;
    });
  }

  getIntercom(): any {
    return this.intercom;
  }
}
